import { render, staticRenderFns } from "./EditBlockSlideshowSettingsTabSettings.vue?vue&type=template&id=6c326742&"
import script from "./EditBlockSlideshowSettingsTabSettings.vue?vue&type=script&lang=js&"
export * from "./EditBlockSlideshowSettingsTabSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports